import {HttpBackend, HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Translation, TranslocoLoader} from '@jsverse/transloco';
import {TranslocoLoaderData} from '@jsverse/transloco/lib/transloco.loader';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../environments/environment';

/** Transloco 4.2.6 support multi scope loading, but do not described it */
type MultiTranslationResult = [{ lang: string; translation: Observable<Translation> }];

let rootTranslationLoaded = false;

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http: HttpClient;
    private readonly langFilesMapper ={
        'sl':'sk'
    }

  constructor(httpBackend:HttpBackend) {
       this.http = new HttpClient(httpBackend);
  }

  getTranslation(scopeAndLang: string, data?: TranslocoLoaderData): Observable<Translation | MultiTranslationResult> {
    const rootLoaded = rootTranslationLoaded;
    const assetUrl = environment.locale.localeUrl;
    scopeAndLang = this.langFilesMapper[scopeAndLang] ?? scopeAndLang;

    if(!assetUrl){
        throw new Error("The locale path url is not defined. Please provide a valid url in environment file");
    }

    rootTranslationLoaded = true;
    if (rootLoaded || !data) {

      return this.http.get<Translation>(`${assetUrl}assets/i18n/${scopeAndLang}.json?d=${new Date().getTime()}`)
          .pipe(
              catchError(()=>{
                  console.log(`An error occurred while fetching lang ${scopeAndLang}`);
                  return of({})
              }));
    }
    const splitPath = scopeAndLang.split('/');
    const language = splitPath[splitPath.length > 1 ? 1 : 0];
    return forkJoin(this.listOfTranslation([language, scopeAndLang],assetUrl)).pipe(
      map(list =>
          {

          return Object.entries(list).map(([key, value]) => ({ lang: key, translation: value }))
        }
      )
    );
  }

  private listOfTranslation(scopes: string[], assetUrl: string): { [key: string]: Observable<Translation> } {

      return scopes.reduce((accumulator, scope) => {
      accumulator[scope] = this.http.get<Translation>(`${assetUrl}assets/i18n/${scope}.json?d=${new Date().getTime()}`)
          .pipe(
              catchError(()=>{
                console.log(`An error occurred while fetching lang ${scope}`);
                return of({})
            })
          );
      return accumulator;
    }, {});
  }
}
